import { useEffect, useRef, useState } from "react";

interface LazyChartSectionProps {
  children: React.ReactNode;
  minHeight?: number;
  keepMounted?: boolean;
}

export const LazyChartSection = ({
  children,
  minHeight = 320,
  keepMounted = false,
}: LazyChartSectionProps) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const isIntersecting = entries.some((entry) => entry.isIntersecting);
        setIsVisible(isIntersecting);
      },
      {
        rootMargin: "200px 0px",
        threshold: 0.1,
      }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className="w-full">
      {isVisible || keepMounted ? (
        children
      ) : (
        <div
          style={{ minHeight }}
          className="flex items-center justify-center rounded-md border border-dashed border-border/60 bg-muted/30 text-xs text-muted-foreground"
        >
          Loading chart…
        </div>
      )}
    </div>
  );
};

export default LazyChartSection;
